export function isInsideViewport(element: HTMLVideoElement) : boolean {
	if (element === null) {
		return false;
	}

	const bounding = element.getBoundingClientRect();
	return bounding.top >= 0 &&
		bounding.left >= 0 &&
		bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
		bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight);
}
